import React, {useEffect} from "react";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import {BsSquareFill, BsTagsFill} from "react-icons/bs";
import {getStatusBgColor} from "../../util/bookingUtils";
import {capitalizeWords} from "../../util/common";
import refreshIcon from "../../assets/refresh.png";

const AppointmentDetails = ({ bookingDetails, refreshBookingDetails, assignToMe, unPaidAmt, isRequirePayment }) => {

  return (
    <Col className="pt-30 pb-20">
        <div>
            <h3>Appointment Details &nbsp; &nbsp;

                <img
                    id="refreshBookingDetails"
                    alt="refresh booking details"
                    src={refreshIcon}
                    style={{
                        width: "2vw",
                        height: "2vw",
                        objectFit: "contain",
                        cursor: "pointer",
                        transitionDuration: "1s",
                        marginLeft: 10
                    }}
                    onClick={e => {
                        e.stopPropagation();
                        const buttonId = document.getElementById("refreshBookingDetails");
                        buttonId.disabled = true;
                        buttonId.style.transform = "rotate(360deg)";
                        refreshBookingDetails();
                        setTimeout(() => {buttonId.style.transform = "rotate(0deg)"}, 1000);
                    }}
                />
            </h3>
            <h6>
                <span><BsSquareFill color={getStatusBgColor(bookingDetails?.bookingStatus)} />&nbsp; &nbsp; {capitalizeWords(bookingDetails?.bookingStatus)}</span>
                <span>
                {bookingDetails?.tagOrLabel && (
                    <>
                        &nbsp;  | &nbsp;<BsTagsFill/> &nbsp; <span>{bookingDetails.tagOrLabel}</span>
                    </>
                )}
            </span>
            </h6>
        </div>
      <h5>{bookingDetails?.primaryClinicianName ? `Primary Clinician - ${bookingDetails.primaryClinicianName}` : "No Primary Clinician"}</h5>
      <Button
        variant="light"
        style={{
          width: "auto",
          color: "white",
          background: "#866BD9",
          border: 0
        }}
        disabled={bookingDetails?.isAssignedToMe === true
            || bookingDetails?.isReadOnly
            || bookingDetails?.hasWriteAccessToClinicalData === false}
        onClick={() => assignToMe(bookingDetails?.id)}
      >
        {bookingDetails?.isAssignedToMe === true ? "Assigned to you" : bookingDetails?.primaryClinicianId ? "Re-assign to me" : "Assign to me"}
      </Button>
        {/*{isRequirePayment === true && <h4 style={{ fontWeight:"bold", color: "red", marginBlock: 14 }}>*/}
        {/*    <BsCashCoin/>*/}
        {/*        <span>&nbsp;This Booking has an outstanding amount of ${unPaidAmt} to be collected&nbsp;</span>*/}
        {/*    <BsCashCoin/>*/}
        {/*</h4>}*/}
        {bookingDetails?.bookingStatus === "CANCELLED" && <h5 style={{ color: "red", marginBlock: 14 }}>This Booking has been CANCELLED</h5>}
        {bookingDetails?.bookingStatus === "COMPLETED" && <h5 style={{ color: "green", marginBlock: 15 }}>This Booking has been COMPLETED</h5>}
    </Col>
  );
};

export default AppointmentDetails;
